import {Fragment} from "react";
import {Table, TableBody, TableCell, TableRow} from "@mui/material";
import UnlinkButton from "./UnlinkButton";
import FormattedTableHead from "../../../FormattedTableHead";
import NoDeviceBlock from "../NoDeviceBlock";
import {HasPermission} from "../../../widgets";
import {LinkedDevicesQueryHookResult} from "../queries.generated";
import {defineMessages} from "react-intl";
import {commonTranslations} from "@/utils/translations";

const translations = defineMessages({
    linkedUser: {
        id: "linkedExtension.user",
        defaultMessage: "Linked user",
    },
    unlink: {
        id: "linkedExtension.unlink",
        defaultMessage: "Unlink",
    },
});

type Props = {
    query: LinkedDevicesQueryHookResult;
};

export default ({query}: Props) => {
    if (!query.data.linkedDevices.length) return <NoDeviceBlock idSuffix="linked" />;

    return (
        <Fragment>
            <Table>
                <FormattedTableHead
                    cells={[
                        {label: translations.linkedUser},
                        {label: commonTranslations.macAddress},
                        {label: translations.unlink, props: {align: "center"}},
                    ]}
                />
                <TableBody>
                    {query.data.linkedDevices.map((device) => (
                        <TableRow key={device.id}>
                            <TableCell>{device.name}</TableCell>
                            <TableCell>{device.macAddress}</TableCell>
                            <TableCell align="center">
                                <HasPermission name="edit_extension">
                                    <UnlinkButton onSuccess={query.refetch} name={device.name} id={device.id} />
                                </HasPermission>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Fragment>
    );
};
